enum LogLevel {
  Debug = 2,
  Info = 3,
  Warn = 4,
  Error = 5,
}

export { LogLevel };
